// libs
import React, { memo } from 'react';

// components
import SomethingWentWrong from 'shared/components/SomethingWentWrong';
import EmptyWishlist from 'shared/layouts/Wishlist/Mobile/components/EmptyWishlist';

// contexts
import { useWishlistContext } from 'shared/layouts/Wishlist/API/context';

interface IWishlistErrorWrapper {
  totalProducts: number;
  children: React.ReactNode;
}
function WishlistErrorWrapper({ totalProducts, children }: IWishlistErrorWrapper) {
  const { isFetching, isError, errorStatusCode } = useWishlistContext();

  if (isError) {
    return <SomethingWentWrong statusCode={errorStatusCode} />;
  }

  if (totalProducts === 0 && !isFetching) {
    return <EmptyWishlist />;
  }

  return <>{children}</>;
}

export default memo(WishlistErrorWrapper);
